import React from 'react'
import { Modal, ModalBody, ModalHeader } from 'reactstrap'
import { AppDownloadPopupImage, CloseIcon } from '../../assets/images';
import "./style.scss"

type AppProps = {
    isDownloadMobileApp: boolean;
    setIsDownloadMobileApp: React.Dispatch<React.SetStateAction<boolean>>;
}

const DownloadMobileApp = ({ isDownloadMobileApp, setIsDownloadMobileApp }: AppProps) => {

    const handleToggle = () => {
        setIsDownloadMobileApp((prev: boolean) => !prev)
    }
    return (
        <Modal className='downloadAppModal' isOpen={isDownloadMobileApp} toggle={handleToggle} size='xl' centered>

            <button
                className="custom-close-button"
                onClick={handleToggle}
                aria-label="Close"
            >
                <img src={CloseIcon} alt="close" />
            </button>



            <ModalBody style={{ padding: 0, margin: 0 }}>
                <img src={AppDownloadPopupImage} style={{ width: "100%" }} alt='app-download' />
            </ModalBody>
        </Modal>
    )
}

export default DownloadMobileApp